import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Printer, CheckCircle2 } from 'lucide-react';
import { fmtDate, fmtDateTime } from './guiasUtils';

export const Comprovante = ({ data, onClose }) => {
  if (!data) return null;
  const Row = ({ l, v }) => <div className="flex justify-between gap-4 py-1 border-b border-dashed last:border-0"><span className="text-muted-foreground">{l}</span><span className="font-medium text-right">{v}</span></div>;
  return (
    <Dialog open={!!data} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md print:max-w-full" data-testid="comprovante-dialog">
        <DialogHeader><DialogTitle className="text-center">COMPROVANTE DE RECEBIMENTO DE GUIAS</DialogTitle><DialogDescription className="text-center">Registro digital do recebimento conferido</DialogDescription></DialogHeader>
        <div id="comprovante-print" className="text-sm space-y-3">
          <p className="text-center text-2xl font-bold tracking-wider text-primary" data-testid="comprovante-numero">{data.numero_recebimento}</p>
          <div>
            <Row l="Profissional" v={data.profissional_nome} />
            <Row l="Categoria" v={data.categoria_label} />
            <Row l="Competência" v={fmtDate(data.competencia)} />
            <Row l="Pacientes" v={data.total_pacientes} />
            <Row l="Guias recebidas" v={data.total_guias} />
            <Row l="Guias conferidas" v={data.total_conferidas} />
            <Row l="Divergências" v={data.total_divergencias} />
            <Row l="Entregue por" v={`${data.entregue_por_nome} · ${fmtDateTime(data.entregue_em)}`} />
            <Row l="Responsável pelo recebimento" v={data.recebido_por_nome} />
            <Row l="Data / Hora" v={fmtDateTime(data.recebido_em)} />
          </div>
          <div className="flex items-center justify-center gap-2 rounded bg-emerald-50 dark:bg-emerald-950/20 text-emerald-700 dark:text-emerald-300 font-bold py-2"><CheckCircle2 className="h-5 w-5" />{data.status}</div>
          <details className="text-xs">
            <summary className="cursor-pointer text-muted-foreground">Pacientes relacionados ({data.pacientes.length})</summary>
            <ol className="list-decimal pl-5 mt-1 space-y-0.5">{data.pacientes.map((p) => <li key={p.paciente_id}>{p.paciente_nome}</li>)}</ol>
          </details>
        </div>
        <Button variant="outline" onClick={() => window.print()} data-testid="btn-imprimir-comprovante"><Printer className="h-4 w-4 mr-2" />Imprimir / Salvar PDF</Button>
      </DialogContent>
    </Dialog>
  );
};
